// @flow

import { checkHttpStatus, getApiHeaders, getApiBaseUrl } from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/account'
import { getErrorAction } from '../utils/actions'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST'
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS'
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE'
export const IS_EDITING_ACCOUNT = 'IS_EDITING_ACCOUNT'
export const IS_NOT_EDITING_ACCOUNT = 'IS_NOT_EDITING_ACCOUNT'

export function isEditingAccount(): Action {
  return {
    type: IS_EDITING_ACCOUNT
  }
}

export function isNotEditingAccount(): Action {
  return {
    type: IS_NOT_EDITING_ACCOUNT
  }
}

export function changePasswordSuccess(): Action {
  return {
    type: CHANGE_PASSWORD_SUCCESS
  }
}

export function changePasswordFailure(error: APIError): Action {
  return getErrorAction(
    CHANGE_PASSWORD_FAILURE,
    error,
    'Current password is incorrect'
  )
}

export function changePasswordRequest(): Action {
  return {
    type: CHANGE_PASSWORD_REQUEST
  }
}

export function changePasswordReset(): Action {
  return {
    type: CHANGE_PASSWORD_RESET
  }
}

export function updateAccountSuccess(
  userId: number,
  url: ?string,
  about: ?string
): Action {
  return {
    type: UPDATE_ACCOUNT_SUCCESS,
    userId: userId,
    file: url,
    about: about
  }
}

export function updateAccountFailure(error: {
  response: { status: number, statusText: string }
}): Action {
  return getErrorAction(
    UPDATE_ACCOUNT_FAILURE,
    error,
    'There was an issue uploading your photo. Please try again.'
  )
}

export function updateAccountRequest(): Action {
  return {
    type: UPDATE_ACCOUNT_REQUEST
  }
}

export function changePassword(
  currentPassword: string,
  newPassword: string
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(changePasswordRequest())

    try {
      checkHttpStatus(
        await fetch(`${getApiBaseUrl()}/api/user/update_password`, {
          method: 'PUT',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            user: {
              current_password: currentPassword.trim(),
              new_password: newPassword.trim()
            }
          })
        })
      )

      dispatch(changePasswordSuccess())
    } catch (error) {
      dispatch(changePasswordFailure(error))
    }
  }
}

export function updateAccount(file: ?string, about: ?string): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(updateAccountRequest())
    dispatch(isEditingAccount())

    const data = new FormData()
    if (file) {
      data.append('user[photo]', file)
    }

    if (about !== null && about !== undefined) {
      data.append('user[about]', about || '')
    }

    try {
      const response = checkHttpStatus(
        await fetch(`${getApiBaseUrl()}/api/user`, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.auth.token}"`,
            Accept: 'application/vnd.oefngl.v4'
          },
          body: data
        })
      )

      const json = await response.json()
      dispatch(
        updateAccountSuccess(state.auth.user.id, json.photo_url, json.about)
      )
      dispatch(isNotEditingAccount())
    } catch (error) {
      dispatch(updateAccountFailure(error))
    }
  }
}
